import { MantineSize, MultiSelectProps } from "@mantine/core"
import { useState } from "react"

import { useAsyncSearch } from "../../../hooks/useAsyncSearch"
import { MultiSelect } from "../MultiSelect/MultiSelect"

type AsyncMultiSelectProps<T extends Record<string, any>> = {
  value: string[]
  options: { label: string; value: string }[] | undefined
  asyncRefetch?: (searchQuery?: string) => Promise<T[]>
  isAsyncLoading?: boolean
  onChange: (val: string[]) => void
  nothingFoundMessage?: string
  size?: MantineSize
} & Omit<MultiSelectProps, "value" | "onChange">

export const AsyncMultiSelect = <T extends Record<string, any>>({
  value,
  options,
  asyncRefetch,
  isAsyncLoading,
  onChange,
  nothingFoundMessage = "No options found",
  size = "xs",
  ...props
}: AsyncMultiSelectProps<T>) => {
  const { searchValue, setSearchValue, inputRef } = useAsyncSearch(asyncRefetch)

  const [searchable, setSearchable] = useState(false)

  return (
    <MultiSelect
      searchable={searchable}
      value={value}
      ref={inputRef}
      size={size}
      data={options || []}
      searchValue={searchValue}
      onSearchChange={setSearchValue}
      onChange={onChange}
      disabled={isAsyncLoading}
      placeholder={isAsyncLoading ? "Loading..." : "Search and select..."}
      comboboxProps={{
        withinPortal: false,
      }}
      nothingFoundMessage={nothingFoundMessage}
      onFocus={() => setSearchable(true)}
      onBlur={() => setSearchable(false)}
      {...props}
    />
  )
}
